import { Component, OnInit } from '@angular/core';
import { Roles } from '../../models/roles';
import { AppService } from '../../services/app.service';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/users.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  roles = Roles;
  hideZeroBalances = false;
  hideAllBalances = false;
  private readonly hideZeroBalancesStorageKey =
    'transferswap_sidebar_hide_zero_balances';
  private readonly hideAllBalancesStorageKey =
    'transferswap_sidebar_hide_all_balances';

  constructor(
    public authService: AuthService,
    public appService: AppService,
    public userService: UserService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.hideZeroBalances = this.readBooleanFromStorage(
      this.hideZeroBalancesStorageKey,
      false,
    );
    this.hideAllBalances = this.readBooleanFromStorage(
      this.hideAllBalancesStorageKey,
      false,
    );
  }

  shouldShowVerificationRequest(): boolean {
    return (
      !this.authService.isComplianceApproved() &&
      !this.authService.isComplianceOperationExempt()
    );
  }

  toggleSidebarMinimized() {
    this.appService.setSidebarMinimized(!this.appService.minimized);
  }

  toggleHideZeroBalances() {
    this.hideZeroBalances = !this.hideZeroBalances;
    this.writeBooleanToStorage(
      this.hideZeroBalancesStorageKey,
      this.hideZeroBalances,
    );
  }

  toggleHideAllBalances() {
    this.hideAllBalances = !this.hideAllBalances;
    this.writeBooleanToStorage(
      this.hideAllBalancesStorageKey,
      this.hideAllBalances,
    );
  }

  viewCurrency(currency: any) {
    this.router.navigate(['transactions'], {
      queryParams: { currency: currency },
    });
  }

  getCurrencyKind(currencies: any, type: string) {
    if (!currencies || !Array.isArray(currencies)) return [];
    return (
      currencies.filter((el: any) => el?.currency_type?.name === type) || []
    );
  }

  getBalanceNumber(balance: string | undefined | null) {
    return Number(balance) || 0;
  }

  getCurrenciesByType(type: string) {
    const currencies = this.getCurrencyKind(
      this.userService.user_balance_config?.currencies,
      type,
    );

    if (!this.hideZeroBalances) return currencies;

    return currencies.filter(
      (currency: any) => this.getBalanceNumber(currency?.balance?.total) > 0,
    );
  }

  getDisplayBalance(currency: any) {
    const amount = this.getBalanceNumber(currency?.balance?.total);

    return amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 8,
    });
  }

  findService(currency: any, service: string) {
    return currency.services.find((el: any) => el.name === service)
      ?.provider_services.length;
  }

  private readBooleanFromStorage(key: string, fallback: boolean) {
    try {
      const storedValue = localStorage.getItem(key);
      if (storedValue === null) return fallback;
      return storedValue === 'true';
    } catch {
      return fallback;
    }
  }

  private writeBooleanToStorage(key: string, value: boolean) {
    try {
      localStorage.setItem(key, String(value));
    } catch {
      // Ignore storage errors to keep the sidebar functional.
    }
  }
}
